const loginTypes = {
  SET_PHONE_NUMBER: "SET_PHONE_NUMBER",
  SET_SENT_CODE: "SET_SENT_CODE",

  SET_NAME: "SET_NAME",
  SET_MELLI: "SET_MELLI",
  SET_REFERALL_MOBILE: "SET_REFERALL_MOBILE",
  SET_SURVEY: "SET_SURVEY",
  SET_USER_TOKEN: "SET_USER_TOKEN",
  SET_PASSWORD: "SET_PASSWORD",
  SET_USERNAME: "SET_USERNAME",

  FETCH_LOGINPHONE_START: "FETCH_LOGINPHONE_START",
  FETCH_LOGINPHONE_SUCCESS: "FETCH_LOGINPHONE_SUCCESS",
  FETCH_LOGINPHONE_FAILURE: "FETCH_LOGINPHONE_FAILURE",

  FETCH_LOGINPHONECONFIRM_START: "FETCH_LOGINPHONECONFIRM_START",
  FETCH_LOGINPHONECONFIRM_SUCCESS: "FETCH_LOGINPHONECONFIRM_SUCCESS",
  FETCH_LOGINPHONECONFIRM_FAILURE: "FETCH_LOGINPHONECONFIRM_FAILURE",

  FETCH_LOGINUSERNAMECONFIRM_START: "FETCH_LOGINUSERNAMECONFIRM_START",
  FETCH_LOGINUSERNAMECONFIRM_SUCCESS: "FETCH_LOGINUSERNAMECONFIRM_SUCCESS",
  FETCH_LOGINUSERNAMECONFIRM_FAILURE: "FETCH_LOGINUSERNAMECONFIRM_FAILURE",

  SET_LOGINPHONENUMBER_ISVALID: "SET_LOGINPHONENUMBER_ISVALID",

  SET_LOGIN_STEP: "SET_LOGIN_STEP",
  SET_QUERY_OBJECT: "SET_QUERY_OBJECT",
  SET_USER_COOKIE: "SET_USER_COOKIE",
};

export const loginSteps = {
  initial: -1,
  first: 0,
  second: 1,
  third: 2,
};

export default loginTypes;
